// Apply a specific class to the html element for browser support of cookies.
if (navigator.cookieEnabled) {
  document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies')
}

document.addEventListener('DOMContentLoaded', () => {
  window.lazy = new LazyLoad({
    elements_selector: '.lazy',
    LoadMode: 1 // 0 -> don't load anything | 1 -> Only load visible els | 2 -> Load also very near view els | 3 -> Load also not so near view els
  })

  animateFormLabels()
  blankAttacks()
  toggleAccessibility()
  productTileFormEvents()
  productTileFormInit()
})

window.addEventListener('load', () => {
  initHotspots()
})

window.animateFormLabels = () => {
  // animate form labels when input's not empty on page load, onchange handled inline on inputs, empty focus state handled via css
  document.querySelectorAll('.form__el--animate-label').forEach(el => el.value !== '' ? el.classList.add('form__el--active') : el.classList.remove('form__el--active'))
}

// Dispatch custom key events
document.addEventListener('keydown', e => {
  if (e.key === 'Escape') document.dispatchEvent(new CustomEvent('keydown:Escape'))
})

window.debounce = (func, delay, immediate) => {
  let timerId
  return (...args) => {
    const boundFunc = func.bind(this, ...args)
    clearTimeout(timerId)
    if (immediate && !timerId) {
      boundFunc()
    }
    const calleeFunc = immediate ? () => { timerId = null } : boundFunc
    timerId = setTimeout(calleeFunc, delay)
  }
}

window.slugify = (string) => {
  const a = 'àáâäæãåāăąçćčđďèéêëēėęěğǵḧîïíīįìıİłḿñńǹňôöòóœøōõőṕŕřßśšşșťțûüùúūǘůűųẃẍÿýžźż·/_,:;'
  const b = 'aaaaaaaaaacccddeeeeeeeegghiiiiiiiilmnnnnoooooooooprrsssssttuuuuuuuuuwxyyzzz------'
  const p = new RegExp(a.split('').join('|'), 'g')

  return string.toString().toLowerCase()
    .replace(/\s+/g, '-') // Replace spaces with -
    .replace(p, c => b.charAt(a.indexOf(c))) // Replace special characters
    .replace(/&/g, '-and-') // Replace & with 'and'
    .replace(/[^\w\-]+/g, '') // Remove all non-word characters
    .replace(/\-\-+/g, '-') // Replace multiple - with single -
    .replace(/^-+/, '') // Trim - from start of text
    .replace(/-+$/, '') // Trim - from end of text
}

window.loadStylesheet = src => {
  const $firstScript = document.getElementsByTagName('script')[0]
  const $stylesheet = document.createElement('link')
  $stylesheet.rel = 'stylesheet'
  $stylesheet.type = 'text/css'
  $stylesheet.href = src
  $firstScript.parentNode.insertBefore($stylesheet, $firstScript)
}

window.loadScript = src => {
  const $firstScript = document.getElementsByTagName('script')[0]
  const $script = document.createElement('script')
  $script.async = true
  $script.src = src
  $firstScript.parentNode.insertBefore($script, $firstScript)
}

window.addEventListener('resize', window.debounce(() => {
  toggleAccessibility()
}, 500), { passive: true })

window.imgURL = (src, size, center = false) => {
  if (!src || typeof src === 'undefined') return

  const centerVal = center ? '_crop_center' : ''
  const count = (src.match(/\.jpg|\.png|\.gif|\.jpeg/g) || []).length

  if (count > 1) return src

  return src
    .replace(/_(pico|icon|thumb|small|compact|medium|large|grande|original|1024x1024|2048x2048|master)+\./g, '.')
    .replace(/\.gif/g, match => {
      return '_' + size + centerVal + match
    })
    .replace(/\.jpg|\.png|\.jpeg/g, match => {
      return '_' + size + centerVal + '.progressive' + match
    })
}

const blankAttacks = () => {
  const links = document.querySelectorAll('a[target="_blank"]')

  links.forEach((link) => {
    if (!link.hasAttribute('rel')) {
      link.setAttribute('rel', 'noopener noreferrer')
    } else {
      if (!link.getAttribute('rel').includes('noopener')) {
        link.setAttribute('rel', `${link.getAttribute('rel')} noopener`)
      }
      if (!link.getAttribute('rel').includes('noreferrer')) {
        link.setAttribute('rel', `${link.getAttribute('rel')} noreferrer`)
      }
    }
  })
}

const setNodeInert = (node, value) => {
  if (node && 'inert' in node) node.inert = value
}

const syncInertFromAriaHidden = ($el) => {
  const hidden = $el.attr('aria-hidden') === 'true'
  $el.each((_, node) => setNodeInert(node, hidden))
}

const toggleAccessibility = () => {
  $('[data-toggle]').each((i, e) => {
    const el = $(e)
    const parent = el.parent()
    const target = parent.find(el.data('toggle'))
    const width = el.data('toggle-max-width')
    const buttons = target.find('button')
    const links = target.find('a')

    el.attr('tabindex', '0').attr('role', 'button')

    if (typeof width !== 'undefined' && window.innerWidth >= width) {
      el.attr('aria-expanded', 'true')
      target.attr('aria-hidden', 'false')
      buttons.attr('tabindex', '0')
      links.attr('tabindex', '0')
      syncInertFromAriaHidden(target)
    } else {
      if (parent.hasClass('active-toggle')) {
        el.attr('aria-expanded', 'true')
        target.attr('aria-hidden', 'false')
        buttons.attr('tabindex', '0')
        links.attr('tabindex', '0')
      } else {
        el.attr('aria-expanded', 'false')
        target.attr('aria-hidden', 'true')
        buttons.attr('tabindex', '-1')
        links.attr('tabindex', '-1')
      }
      syncInertFromAriaHidden(target)
    }
  })
}

const dataToggle = (e) => {
  const speed = 400
  const toggleData = e.data('toggle')
  const container = e.closest(`:has(${toggleData})`)
  const target = e.closest(container).find(toggleData)
  const buttons = target.find('button')
  const links = target.find('a')

  // Toggle siblings (if [data-siblings] is set)
  if (e.data('toggle-siblings')) {
    const siblings = e.closest(e.data('toggle-siblings')).siblings().find(toggleData)
    siblings.slideUp(speed).closest('.active-toggle').removeClass('active-toggle')
  }

  e.closest(container).toggleClass('active-toggle').find(toggleData).slideToggle(speed)

  e.attr('aria-expanded', e.attr('aria-expanded') === 'false' ? 'true' : 'false')
  target.attr('aria-hidden', target.attr('aria-hidden') === 'false' ? 'true' : 'false')
  syncInertFromAriaHidden(target)
  buttons.attr('tabindex', buttons.attr('tabindex') === '-1' ? '0' : '-1')
  links.attr('tabindex', links.attr('tabindex') === '-1' ? '0' : '-1')
}

$(document).on('click', '[data-toggle]', (e) => {
  const el = $(e.currentTarget)
  const toggleMaxWidth = typeof el.data('toggle-max-width') !== 'undefined' ? el.data('toggle-max-width') : null
  // Toggle if under the data=toggle-max-width, or if there is no data-toggle-max-width set
  if ((toggleMaxWidth !== null && window.innerWidth < toggleMaxWidth) || toggleMaxWidth === null) {
    dataToggle(el)
    return false
  }
})

$(document).on('click', '[data-toggle-class]', (e) => {
  const el = $(e.currentTarget)
  const className = el.data('toggle-class')
  // You can override by setting data-toggle-class-on='any-element'
  const target = typeof el.data('toggle-class-on') === 'undefined' ? $('html') : $(el.data('toggle-class-on'))

  target.toggleClass(className)
  return false
})

$(document).on('click', '[data-toggle-transition]', (e) => {
  const el = $(e.currentTarget)
  const className = el.data('toggle-transition').class
  const duration = el.data('toggle-transition').duration
  // You can override by setting data-toggle-class-on='any-element'
  const target = typeof el.data('toggle-class-on') === 'undefined' ? $('html') : $(el.data('toggle-class-on'))

  target.addClass(className)

  setTimeout(() => {
    target.removeClass(className)
  }, duration)
})

// Global Hotspots
const initHotspots = () => {
  const breakpoint = window.matchMedia('(min-width: 768px)')
  const hotspots = document.querySelectorAll('[data-page-hero-hotspot]')

  const hotspot = () => {
    for (const hotspot of hotspots) {
      const handle = hotspot.getAttribute('data-page-hero-hotspot-product-handle')

      if (handle !== '') {
        $.getJSON(`/products/${handle}.js`, (response) => {
          const picture = hotspot.querySelector('[data-page-hero-hotspot-picture]')
          const title = hotspot.querySelector('[data-page-hero-hotspot-title]')
          const override = title.getAttribute('data-page-hero-hotspot-title')

          picture.innerHTML = `
            <source data-srcset="${window.imgURL(response.featured_image, '147x107', true)} 1x, ${window.imgURL(response.featured_image, '294x214', true)} 2x" media="(min-width: 1400px)">
            <source data-srcset="${window.imgURL(response.featured_image, '118x86', true)} 1x, ${window.imgURL(response.featured_image, '236x172', true)} 2x" media="(min-width: 1024px)">
            <source data-srcset="${window.imgURL(response.featured_image, '90x66', true)} 1x, ${window.imgURL(response.featured_image, '180x131', true)} 2x" media="(min-width: 768px)">
            <source data-srcset="${window.imgURL(response.featured_image, '118x86', true)} 1x, ${window.imgURL(response.featured_image, '236x172', true)} 2x">
            <img
              data-src="${window.imgURL(response.featured_image, '50x36', true)}"
              alt="${response.title} Product Image"
              height="107"
              width="147"
              class="lazy"
            >
          `
          title.textContent = override || response.title
          hotspotTooltip()
          if (window.lazy) {
            window.lazy.update()
          }
          if (hotspot.classList.contains('loading')) {
            hotspot.classList.remove('loading')
          }
        })

        if (Modernizr.touchevents) {
          document.addEventListener('click', (e) => {
            const el = e.target

            if (el.matches('[data-page-hero-hotspot-button]')) {
              hotspot.classList.toggle('show-tooltip')
            } else {
              const active = document.querySelector('[data-page-hero-hotspot].show-tooltip')

              if (active) {
                active.classList.remove('show-tooltip')
              }
            }
          })
        } else {
          hotspot.addEventListener('mouseenter', () => {
            hotspot.classList.add('show-tooltip')
          }, { passive: true })

          hotspot.addEventListener('mouseleave', () => {
            if (hotspot.classList.contains('show-tooltip')) {
              hotspot.classList.remove('show-tooltip')
            }
          }, { passive: true })
        }
      }
    }
  }

  const hotspotPosition = () => {
    for (const hotspot of hotspots) {
      const xAxis = breakpoint.matches ?
        hotspot.getAttribute('data-page-hero-hotspot-x-axis') :
        hotspot.getAttribute('data-page-hero-hotspot-x-axis-mobile')
      const yAxis = breakpoint.matches ?
        hotspot.getAttribute('data-page-hero-hotspot-y-axis') :
        hotspot.getAttribute('data-page-hero-hotspot-y-axis-mobile')

      hotspot.style.left = `${xAxis}%`
      hotspot.style.top = `${yAxis}%`
    }
  }

  const hotspotTooltip = () => {
    for (const hotspot of hotspots) {
      const tooltip = hotspot.querySelector('[data-page-hero-hotspot-tooltip]')
      const tooltipHeight = Number(tooltip.offsetHeight).toFixed()

      tooltip.style.marginTop = `-${tooltipHeight / 2}px`
    }
  }

  if (hotspots) {
    hotspot()
    hotspotPosition()

    window.addEventListener('resize', window.debounce(() => {
      hotspotPosition()
      hotspotTooltip()
    }, 100), { passive: true })

    document.addEventListener('scroll', () => {
      const active = document.querySelector('[data-page-hero-hotspot].show-tooltip')

      if (active) {
        active.classList.remove('show-tooltip')
      }
    }, { passive: true })
  }
}

const productTileFormEvents = () => {
  document.addEventListener('click', (e) => {
    const el = e.target

    if (el.matches('[data-product-item] [data-product-tile-quantity-update]')) {
      const container = el.closest('[data-product-tile-quantity]')
      const input = container.querySelector('[data-product-tile-quantity-input]')
      const value = Number(input.value)
      const type = el.getAttribute('data-product-tile-quantity-update')

      if (type == 'minus' && value != 1) {
        input.value = value - 1
      }

      if (type == 'plus') {
        input.value = value + 1
      }
    }
  })

  document.addEventListener('submit', (e) => {
    const form = e.target

    if (form.matches('[data-product-item] form[action="/cart/add"]')) {
      e.preventDefault()

      const button = form.querySelector('[name="add"]')
      const select = form.querySelector('[data-product-select]')
      const quantity = form.querySelector('[name="quantity"]')

      window.addToCart(button, {
        id: select.value,
        quantity: Number(quantity.value)
      })
    }
  })

  $(document).on('click', '[data-product-item] [data-product-tile-color-button]', (e) => {
    const button = $(e.currentTarget)
    const value = button.data('product-tile-color-button')
    const container = button.closest('[data-product-item]')
    const label = container.find('[data-product-tile-color-label]')
    const select = container.find('[data-single-option-selector="color"]')
    const buttons = container.find('[data-product-tile-color-button]')

    const imgContainer = container.find('[data-product-image-holder]')[0]
    const coverImg = imgContainer.querySelector('[product-image-cover]')

    const form = container.find('[data-product-tile-form]')[0]
    const formColorSelectorContainer = form.querySelector('[product-color-selector-container]')
    const colorOptions = Array.from(formColorSelectorContainer.querySelectorAll('[data-product-tile-color-button]'))

    const variants = container.find('[data-product-tile-variants-json]').data('product-tile-variants-json')

    buttons.removeClass('active')
    button.addClass('active')
    label.text(value)
    select.val(value).trigger('change')

    let selectedColor
    let currentVariant

    for (let i = 0; i < colorOptions.length; i++) {
      if (colorOptions[i].classList.contains('active')) {
        selectedColor = colorOptions[i].getAttribute('aria-label')
      }
    }

    for (let j = 0; j< variants.length; j++) {
      if (variants[j].option1 == selectedColor || variants[j].option2 == selectedColor || variants[j].option3 == selectedColor || variants[j].option4 == selectedColor) {
        currentVariant = variants[j]
        break
      }
    }

    if (currentVariant.featured_image) {
      coverImg.removeAttribute('srcset')
      coverImg.removeAttribute('src')
  
      coverImg.alt = currentVariant.featured_image.alt
      coverImg.src = currentVariant.featured_image.src

    } else if ( currentVariant.image ) {
      coverImg.removeAttribute('srcset')
      coverImg.removeAttribute('src')
      coverImg.src = currentVariant.image
      coverImg.alt = currentVariant.title
    }
  })

  $(document).on('click', '[data-product-item] [data-product-mobile-cart-add]', (e) => {
    const button = $(e.currentTarget)
    const container = button.closest('[data-product-item]')
    const form = container.find('[data-product-tile-form]')

    form.addClass('mobile-add')
    console.log(form)
  })

  $(document).on('click', '[data-product-mobile-cart-add-close]', () => {
    $('[data-product-tile-form].mobile-add').removeClass('mobile-add')
  })

  document.addEventListener('cart.addItem', () => {
    $('[data-product-tile-form].mobile-add').removeClass('mobile-add')
    $(document.documentElement).removeClass('mobile-add-to-cart-active')
  })
}

window.productTileForm = () => {
  $('[data-product-tile-form]').each((i, e) => {
    const form = $(e)
    const container = form.closest('[data-product-item]')
    const selects = form.find('[data-single-option-selector]')
    const variants = container.find('[data-product-tile-variants-json]').data('product-tile-variants-json')
    const productSelect = form.find('[data-product-select]')
    const shopCurrency = window.theme.shopCurrency
    const moneyFormat = window.theme.moneyFormat

    const buildButton = (variant) => {
      const button = container.find('[data-product-tile-add-to-cart]')
      const label = container.find('[data-product-tile-add-to-cart-text]')

      if (variant.available) {
        button.removeAttr('disabled');
        label.text(window.theme.strings.addToCart);
      } else {
        button.attr('disabled', 'disabled');
        label.text(window.theme.strings.soldOut);
      }
    }

    const buildPrice = (variant) => {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        container.find('[data-product-tile-price]').html(`
          <span>${Shopify.formatMoney(variant.price, moneyFormat).replace(shopCurrency, '')}</span>
          <s>${Shopify.formatMoney(variant.compare_at_price, moneyFormat).replace(shopCurrency, '')}</s>
        `)
      } else {
        container.find('[data-product-tile-price]').html(`
          <span>${Shopify.formatMoney(variant.price, moneyFormat).replace(shopCurrency, '')}</span>
        `)
      }
    }

    selects.on('change', () => {
      const activeOptions = []
      let value = null

      selects.each((i, e) => {
        const select = $(e)
        activeOptions.push(select.val())
      })

      const text = activeOptions.toString().replaceAll(',', ' / ')
      
      let reversedText = '';
      if (activeOptions.length > 1) {
        reversedText = activeOptions.reverse().toString().replaceAll(',', ' / ');
      }

      productSelect.find('option').each((i, e) => {
        if (text == e.innerText || reversedText == e.innerText) {
          value = e.value;
          return
        }
      })

      productSelect.val(value).trigger('change')

      const index = variants.findIndex((variant) => {
        return variant.id == value
      })

      if (index >= 0) {
        buildButton(variants[index])
        buildPrice(variants[index])
      }
    })
  })
}

const productTileFormInit = () => {
  if ($('[data-product-tile-form]').length) {
    window.productTileForm()
  }
}